import { useContext } from 'react'
import RedAlert from './RedAlert'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'

type Props = {
    handleLogout: AnyFunction
}

function NoOrganisation({
    handleLogout
}: Props) {

    const  {
        userData,
        t
    } = useContext(GlobalContext)




    return <div className={`flex flex-col items-center`}>
        <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 items-center text-center`}>
            <img src={`/icons/tip-icon.png`} alt={''} className={`w-24`} />
            <p className={`text-lg`}>{t('NoOrganisation.NoOrganisation')}</p>

            <Button 
            onClick={handleLogout}
            text={t('Buttons.logOut')}
            />
        </div>
    </div>
}
export default NoOrganisation